/* jshint esversion: 6 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { createContext, useEffect, useRef, useState } from 'react';

const MyContext = createContext();

const MyProvider = ({ children }) => {

    // https://godoctor.cscodetech.cloud

    const ApiBaseUrl = "https://admin.aiahwellness.com";
    const ImgBaseUrl = "https://admin.aiahwellness.com/";

    const [isLoginShow, setIsLoginShow] = useState(false);
    const [isSignUpShow, setIsSignUpShow] = useState(false);
    const [isLogin, setIsLogin] = useState("");
    const [isPayment, setIsPayment] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState("");
    const [patientStatus, setPatientStatus] = useState("");
    const [isShow, setIsShow] = useState(false);
    const [showBox, setshowBox] = useState(false);
    const [isFooter, setIsFooter] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const [activePage, setActivePage] = useState("");
    const [agoraAppId, setAgoraAppId] = useState("");
    const [showCall, setShowCall] = useState(false);
    const [mapKey, setMapKey] = useState("");
    const [transactionid, setTransactionId] = useState("");
    const [apiloading, setApiLoading] = useState(false);
    const [selectproduct, setSelectProduct] = useState("");

    const MenuRef = useRef();

    useEffect(() => {
        if (activePage) {
            sessionStorage.setItem("activepage", activePage);
        }
    }, [activePage]);

    const Value = {
        isLoginShow, setIsLoginShow,
        isSignUpShow, setIsSignUpShow,
        isLogin, setIsLogin,
        isPayment, setIsPayment,
        paymentStatus, setPaymentStatus,
        patientStatus, setPatientStatus,
        isShow, setIsShow,
        showBox, setshowBox,
        isFooter, setIsFooter,
        showMenu, setShowMenu,
        activePage, setActivePage,
        agoraAppId, setAgoraAppId,
        showCall, setShowCall,
        mapKey, setMapKey,
        transactionid, setTransactionId,
        apiloading, setApiLoading,
        selectproduct, setSelectProduct,
        ApiBaseUrl, ImgBaseUrl,
        MenuRef
    };

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    );
};

export { MyContext, MyProvider };
/* jshint ignore:end */